import Vue from 'vue'
import Router from 'vue-router'



import index3 from '@/components/index3'
Vue.use(Router)


export const routes = [
  // {
  //   path: '/',
  //   name: 'LimitLibrary',
  //   component: LimitLibrary
  // }

  {
    path: '/',
    name: 'index3',
    component: index3
  },
  // {
  //   path: '/',
  //   name: 'InfoMonitorIndex',
  //   component: InfoMonitorIndex
  // }
]


const router = new Router({
  mode: "history",
  base:'/sso/picTools/',
  routes
});


export default router



// WEBPACK FOOTER //
// ./src/router/index.js